import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GROLOG_URL } from '../../../../constant/apiConstant';
import { ROUTES } from '../../../../constant/routeConstant';
import { useTranslation } from 'react-i18next';
import { validTemperature } from '../validation-temperature';
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from '../../../../util/Util';

const useAddTemperature = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState('');

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [list, setList] = useState([]);
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [visible, setVisible] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState([]);
  const [err,setErr] = useState("");
  const [showConfirm, setShowConfirm] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  const dispatch = useDispatch()

  const backToList = () => {
    if (!isChanged) {
      navigate(ROUTES.TEMPERATURE_CATEGORY.LIST)
    } else{
      setShowConfirm(true)
    }

  }

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  }

  const getDropdown = async () => {
    setLoading(true)
    let res = await doGet(
      `/uom?page=${page}&limit=${limit}&filter=category eq T`, token
    );

    const list = res?.data?.payload?.data;
    if (list && list.length > 0) {
      mapingList(list)
    } 
    setLoading(false)
  }

  const mapingList = async (data) => {
    const newDatas = data.map((item) => {
      return {label: item?.uom_category_code, value: item?.uom_id}
    });

    setList(newDatas)
  }

  useEffect(() => {
    getDropdown();
  }, [page, limit]);


  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  }

  const _onChange = (val, name) => {
    setIsChanged(true)
    onChanged(dispatch, true)
    setErr("")
    if (name === "uom_id") {
      let eror = validTemperature(name, val, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val,
        };
      });
    } else {
      let eror = validTemperature(name, val.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val.target.value,
        };
      });
    }
  }

  const onSubmit = async () => {
    let errors = {};
    form.code = form.uom_id
    let data = form;
    let keys = {
      name: form.name,
      description: form.description,
      code: form.uom_id,
    }

    for (const key in keys) {
      const option = validTemperature(key, keys[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {

      const api = GROLOG_URL;
      const headers = { "Authorization": token };
      
      axios.post(`${api}/temperature-category?${param}`, data, { headers })
      .then(response => {
        if (response?.status === 200) {
          setSuccessModalOpen(true)
        }
      }).catch((error) => {
        const errorCode =  error?.response?.status;

        if (errorCode === 400) {
          const errorMessage =  error?.response?.data?.payload?.message;
          
          setMessageFailed(errorMessage);
          setFailedModalOpen(true);
        }
      })
    }
    else{
      setError(errors);
    }
  }

  const _onOkSuccesAdd = () => {
    setSuccessModalOpen(false)
    navigate(ROUTES.TEMPERATURE_CATEGORY.LIST)
  }

  return {
    backToList,
    list,
    code,
    visible,
    setVisible,
    _onChange,
    validateSubmit,
    form,
    setForm,
    error,
    setError,
    err,
    setErr,
    onSubmit,
    description,
    setDescription,
    successModalOpen,
    loading,
    setPage,
    setLimit,
    setCode,
    _onOkSuccesAdd,
    failedModalOpen,
    messageFailed,
    setFailedModalOpen,
    setShowConfirm,
    showConfirm
  }
}

export default useAddTemperature;